import React from 'react';



export default function BuyerMapEd() {

  return (
    <>
        <h1>ЦЕЛЕВАЯ СТРАТЕГИЧЕСКАЯ КАНВА</h1>
        <p>Целевая стратегическая канва – это визуальный аналитический инструмент, который иллюстрирует, как ваша стратегия голубого океана отличается от текущих реалий алого океана.</p>
        <img src={`${process.env.PUBLIC_URL}/images/to-Be-ru.jpg`} style={{width: 600}}/>
        <h3>
          Канва содержит:

        </h3>
        <p>
          1. Ключевые факторы конкуренции в вашей отрасли – существующие и новые (горизонтальная ось).
        </p>

        <p>
          2. Уровень предложения, которое получают потребители по каждому фактору конкуренции в отрасли (вертикальная ось).
        </p>

        <p>
          3. Стратегические профили конкурентов и вашей компании.
        </p>
        <p>
          Цель инструмента – совершить переход к голубому океану и визуально изобразить инновацию ценности при низких издержках и отличие от конкурентов.
        </p>

        <h3>
          Алгоритм работы с инструментом:
        </h3>

        <p>
          1. Оцените ключевые факторы, представленные в решетке «Упразднить – снизить – повысить – создать» (так же, как это делали в стратегической канве текущего положения дел).
        </p>
        <p>
          2. Перечислите ключевые факторы, по которым, на ваш взгляд, конкурирует отрасль с точки зрения потребителя.
        </p>
        <p>
          3. Изобразите все факторы на горизонтальной оси. Сначала цену, затем те факторы, которые надо упразднить, а после снизить, повысить и, в самом конце, создать.
        </p>
        <p>
          4. Разместите на стратегической канве стратегические профили ваших конкурентов.
        </p>

        <h3>
          Правила работы с инструментом:
        </h3>

        <p>
          1. Все упраздненные факторы получают оценку 0, остальные - в соответствии со шкалой “высокое значение” - “низкое значение” при увеличении или снижении значения фактора.
        </p>
        <p>
          2. Соблюдайте критерий дивергенции - стратегический профиль вашей компании не должен совпадать со стратегическим профилем конкурентом, быть немного больше или немного меньше по некоторым факторам. В таком случае потребители не будут отличать ваше предложение от предложения конкурентов.
        </p>
        <p>
          3. Соблюдайте критерий фокуса - стратегический профиль вашей компании должен быть сфокусирован. Он должен сосредотачиваться на ключевых факторах, способных создать скачок ценности для потребителей и при этом упразднить и снизить влияние других элементов.
        </p>



    </>
  )
}
